import { followGoal, fetchPinnedGoals } from '@api/fetchers/goal/updaters';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { useUpdateSelectedGoal } from '@api/hooks/topology/useSelectedGoal';
import { useCallback, useRef } from 'react';
import { emptyList } from '@constants/empty';
import { segment } from '@actions/analytics';
import { ONBOARDING_GOAL_SELECTED } from '@cont/Homepage/constants/event';
import useFollowedGoals from './goal/useFollowedGoals';

const getIsGoalFollowedByUser = (followedGoals, goalUID) => {
  return !!followedGoals?.find((followedGoal) => followedGoal.uid === goalUID);
};
const useFollowGoal = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const selectGoal = useUpdateSelectedGoal();
  const { followedGoals: followedGoalsByUsers } = useFollowedGoals({
    fallbackData: emptyList
  });
  const isRequestingFollowGoal = useRef(null);
  const followCurrentGoal = useCallback(() => {
    const isGoalFollowedByUser = getIsGoalFollowedByUser(
      followedGoalsByUsers,
      goalUID
    );
    if (isGoalFollowedByUser || isRequestingFollowGoal.current) return null;
    if (goalUID && isLoggedIn) {
      isRequestingFollowGoal.current = true;
      // fetching followed goals by user
      fetchPinnedGoals().then((followedGoals) => {
        if (!followedGoals?.error) {
          const isGoalFollowed = getIsGoalFollowedByUser(
            followedGoals,
            goalUID
          );
          // make api request to follow if goal is not followed by user
          if (!isGoalFollowed) {
            followGoal(goalUID, true).then((response) => {
              if (!response?.error) {
                selectGoal(goalUID);
                segment.track(ONBOARDING_GOAL_SELECTED);
              }
            });
          }
          isRequestingFollowGoal.current = false;
        }
        isRequestingFollowGoal.current = false;
      });
    }
  }, [goalUID, isLoggedIn, selectGoal, followedGoalsByUsers]);

  return { followCurrentGoal };
};

export default useFollowGoal;
